// Fond d'écran + thème — partagés entre LauncherView (qui les affiche) et
// PersonnaliserView (qui les modifie). Port de Client/js/app.js:2279-2282, 2469-2472.
import { defineStore } from 'pinia'

export const usePreferencesStore = defineStore('preferences', {
  state: () => ({
    fondEcran: localStorage.getItem('alexisos-fond-ecran') || 'points',
    themeClair: localStorage.getItem('alexisos-theme-clair') === '1',
  }),
  actions: {
    choisirFondEcran(cle) {
      this.fondEcran = cle
      localStorage.setItem('alexisos-fond-ecran', cle)
    },
    appliquerTheme() {
      document.body.classList.toggle('theme-light', this.themeClair)
      localStorage.setItem('alexisos-theme-clair', this.themeClair ? '1' : '0')
    },
    initTheme() {
      document.body.classList.toggle('theme-light', this.themeClair)
    },
  },
})
